import { createAction } from '@reduxjs/toolkit';

export enum EAdvType {
    phoneTopBanner,
}

export const advUpdated = createAction<EAdvType>('adv/advUpdated');
